import React, { FC, useCallback } from 'react'
import { useHistory, useRouteMatch } from 'react-router-dom'

import { Button, Grid, SvgIcon, Typography } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'

import { routes } from '../../../constants/routes'
import { RootPage } from '../menuTabList'
import { ReactComponent as Chart } from '../../../images/menu/chart_black_24dp.svg'

import { MenuSubTab } from '../MenuSubTab'

interface MenuTabProps {
  item: RootPage
}

const useStyles = (active: boolean) =>
  makeStyles((theme: Theme) => ({
    tab: {
      minWidth: '100%',
      height: 40,
      display: 'flex',
      justifyContent: 'flex-start',
      margin: '5px 0',
      padding: '16px ',
      color: active ? theme.palette.primary.light : '#9b9c9f',
      backgroundColor: active ? '#3c5550' : 'inherit',
      '&:hover': {
        background: active ? '#3c5550' : 'transparent',
        color: 'white',
      },
    },
    titleTab: {
      fontSize: 14,
      textTransform: 'none',
      marginLeft: 12,
    },
  }))()

export const MenuTab: FC<MenuTabProps> = ({ item }) => {
  const { name, icon, path, submenu } = item
  const match = useRouteMatch({ path: path || 'unknownPath', exact: false })
  const { tab, titleTab } = useStyles(!!match)
  const history = useHistory()

  const redirect = useCallback(() => {
    if (path) {
      const url = typeof path === 'string' ? path : path[0]
      const paginatedRoutes = [routes.COMPANIES, routes.USERS, routes.TRADING, routes.SETTINGS_ENTITIES]
      history.push(`${paginatedRoutes.includes(url) ? `${url}?page=1` : url}`)
    }
  }, [history, path])

  return (
    <Grid item container direction={'column'}>
      <Button className={`${tab}`} onClick={redirect}>
        {icon ? <span className="material-icons">{icon}</span> : <SvgIcon component={Chart} />}
        <Typography variant={'body1'} className={titleTab}>
          {name}
        </Typography>
      </Button>
      {submenu && match && submenu.map((submenuItem) => <MenuSubTab item={submenuItem} key={submenuItem.name} />)}
    </Grid>
  )
}
